import React from 'react';
import { Box, List, ListItemButton, ListItemText, ListItemIcon } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import TextsmsIcon from '@mui/icons-material/Textsms';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import ImageIcon from '@mui/icons-material/Image';
import HistoryIcon from '@mui/icons-material/History';

const menuOptions = [
    { key: 'sendText', label: 'Send Text', icon: <TextsmsIcon /> },
    { key: 'sendVoice', label: 'Send Voice', icon: <KeyboardVoiceIcon /> },
    { key: 'sendImage', label: 'Send Image', icon: <ImageIcon /> },
    { key: 'history', label: 'History', icon: <HistoryIcon /> },
    { key: 'settings', label: 'Settings', icon: <SettingsIcon /> },
];

const RemindMeSideMenu = ({
    selected,
    onSelect,
}: {
    selected: string;
    onSelect: (key: string) => void;
}) => (
    <Box
        sx={{
            width: 300,
            bgcolor: 'background.paper',
            height: '100vh',
            borderRight: 1,
            borderColor: 'divider',
            py: 2,
        }}
    >
        <List>
            {menuOptions.map(option => (
                <ListItemButton
                    key={option.key}
                    selected={selected === option.key}
                    onClick={() => onSelect(option.key)}
                    sx={{
                        borderRadius: 2,
                        mb: 1,
                        mx: 1,
                        ...(selected === option.key && {
                            bgcolor: 'primary.main',
                            color: 'text.primary',
                            '& .MuiListItemIcon-root': {
                                color: 'text.primary',
                            },
                        }),
                    }}
                >
                    <ListItemIcon sx={{ minWidth: 36 }}>{option.icon}</ListItemIcon>
                    <ListItemText primary={option.label} />
                </ListItemButton>
            ))}
        </List>
    </Box>
);

export default RemindMeSideMenu;